import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import { CONSUMER_CHANNEL_CONFIGURATION_SCREEN, CONSUMER_CHANNEL_CONFIG_CRUMB } from '../../screens/ConsumerChannelsConfigScreen/constants';
import consumerChannelsConfigStore from '../../screens/ConsumerChannelsConfigScreen/store';
import configMobileStore from '../../screens/MobileConfigScreen/stores';
import configWebStore from '../../screens/WebConfigScreen/stores';
import ConsumerChannelsConfigHeaderLinks from '../ConsumerChannelsConfigHeaderLinks/ConsumerChannelsConfigHeaderLinks';
import configKioskStore from '~/view/screens/SettingsScreen/screens/OrderingChannel/screens/KioskConfigScreen/store';
import Crumbs, { CrumbsType, ICrumb } from 'src/view/components/Controls/Crumbs';

interface IProps {
  screen: CONSUMER_CHANNEL_CONFIGURATION_SCREEN;
}

const ConsumerChannelsConfigHeader: FC<IProps> = observer(({ screen }: IProps): JSX.Element => {
  const mobileNavigationCrumbs = useMemo((): ICrumb[] => {
    return [
      {
        value: CONSUMER_CHANNEL_CONFIG_CRUMB.COLORS,
        label: CONSUMER_CHANNEL_CONFIG_CRUMB.COLORS,
        error: !configMobileStore.colorsValidation.isValid,
      },
      { value: CONSUMER_CHANNEL_CONFIG_CRUMB.LAYOUT, label: CONSUMER_CHANNEL_CONFIG_CRUMB.LAYOUT },
      {
        value: CONSUMER_CHANNEL_CONFIG_CRUMB.CONFIGURATION,
        label: CONSUMER_CHANNEL_CONFIG_CRUMB.CONFIGURATION,
        error: !configMobileStore.firebaseValidation.isValid,
      },
    ];
  }, [configMobileStore.colorsValidation.isValid, configMobileStore.firebaseValidation.isValid]);

  const webNavigationCrumbs = useMemo((): ICrumb[] => {
    return [
      { value: CONSUMER_CHANNEL_CONFIG_CRUMB.COLORS, label: CONSUMER_CHANNEL_CONFIG_CRUMB.COLORS, error: !configWebStore.colorsValidation.isValid },
      { value: CONSUMER_CHANNEL_CONFIG_CRUMB.IMAGES, label: CONSUMER_CHANNEL_CONFIG_CRUMB.IMAGES },
      {
        value: CONSUMER_CHANNEL_CONFIG_CRUMB.CONFIGURATION,
        label: CONSUMER_CHANNEL_CONFIG_CRUMB.CONFIGURATION,
        error: !configWebStore.contactValidation.isValid,
      },
    ];
  }, [configWebStore.colorsValidation.isValid, configWebStore.contactValidation.isValid]);

  const kioskNavigationCrumbs = useMemo((): ICrumb[] => {
    return [
      { value: CONSUMER_CHANNEL_CONFIG_CRUMB.COLORS, label: CONSUMER_CHANNEL_CONFIG_CRUMB.COLORS, error: !configKioskStore.colorsValidation.isValid },
      { value: CONSUMER_CHANNEL_CONFIG_CRUMB.IMAGES, label: CONSUMER_CHANNEL_CONFIG_CRUMB.IMAGES, error: !configKioskStore.imagesValidation.isValid },
      {
        value: CONSUMER_CHANNEL_CONFIG_CRUMB.CONFIGURATION,
        label: CONSUMER_CHANNEL_CONFIG_CRUMB.CONFIGURATION,
        error: !configKioskStore.configurationValidation.isValid,
      },
    ];
  }, [configKioskStore.colorsValidation.isValid, configKioskStore.imagesValidation.isValid, configKioskStore.configurationValidation.isValid]);

  const navigationCrumbs = useMemo((): ICrumb[] => {
    switch (true) {
      case screen === CONSUMER_CHANNEL_CONFIGURATION_SCREEN.MOBILE:
        return mobileNavigationCrumbs;
      case screen === CONSUMER_CHANNEL_CONFIGURATION_SCREEN.WEB:
        return webNavigationCrumbs;
      case screen === CONSUMER_CHANNEL_CONFIGURATION_SCREEN.KIOSK:
      default:
        return kioskNavigationCrumbs;
    }
  }, [screen, mobileNavigationCrumbs, webNavigationCrumbs, kioskNavigationCrumbs]);

  return (
    <div className="d-flex flex-column gap-30">
      <ConsumerChannelsConfigHeaderLinks />
      <Crumbs
        type={CrumbsType.TAB}
        activeCrumb={consumerChannelsConfigStore.navigationCrumbs[screen]}
        crumbs={navigationCrumbs}
        onClick={(crumb) => consumerChannelsConfigStore.setNavigationCrumb(crumb, screen)}
        translateLabel
      />
    </div>
  );
});

export default ConsumerChannelsConfigHeader;
